export default __webpack_public_path__ + "static/media/watsapp.99ce26ae.svg";